import { t } from "../../i18n/strings";
import type { Locale } from "../../templates/types";

export function TypingDots({ locale = "en" }: { locale?: Locale } = {}) {
  return (
    <div className="flex items-center gap-1 px-1 py-2" aria-label={t(locale, "chat.typing.ariaLabel")} role="status">
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-ink-soft [animation-delay:-0.3s]" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-ink-soft [animation-delay:-0.15s]" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-ink-soft" />
    </div>
  );
}
